import { TileRateApartment } from '@nocowanie/noc-api';

export const APARTMENT_TYPE_LABEL = {
    [TileRateApartment.type.APARTMENT]: {
        label: 'Apartament',
        type: TileRateApartment.type.APARTMENT,
        guestCapacityLabel: 'osobowy',
    },
    [TileRateApartment.type.ROOM]: {
        label: 'Pokój',
        type: TileRateApartment.type.ROOM,
        guestCapacityLabel: 'osobowy',
    },
    [TileRateApartment.type.RESIDENCE]: {
        label: 'Rezydencja',
        type: TileRateApartment.type.RESIDENCE,
        guestCapacityLabel: 'osobowa',
    },
    [TileRateApartment.type.COTTAGE]: {
        label: 'Domek',
        type: TileRateApartment.type.COTTAGE,
        guestCapacityLabel: 'osobowy',
    },
    [TileRateApartment.type.VILLA]: {
        label: 'Willa',
        type: TileRateApartment.type.VILLA,
        guestCapacityLabel: 'osobowa',
    },
    [TileRateApartment.type.BUNGALOW]: {
        label: 'Bungalow',
        type: TileRateApartment.type.BUNGALOW,
        guestCapacityLabel: 'osobowy',
    },
    [TileRateApartment.type.AGROTOURISM]: {
        label: 'Agroturystyka',
        type: TileRateApartment.type.AGROTOURISM,
        guestCapacityLabel: 'osobowa',
    },
    [TileRateApartment.type.HOUSE]: {
        label: 'Dom',
        type: TileRateApartment.type.HOUSE,
        guestCapacityLabel: 'osobowy',
    },
};
